import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cc69841"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "お知らせ登録", -1))
const _hoisted_2 = {
  id: "notice-form",
  class: "m-auto"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }, null, -1))
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "タイトル", -1))
const _hoisted_6 = ["textContent"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "start-date" }, "掲載開始日", -1))
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "end-date" }, "掲載終了日", -1))
const _hoisted_12 = ["textContent"]
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "body" }, "本文", -1))
const _hoisted_15 = ["textContent"]
const _hoisted_16 = { class: "mt-3" }
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            class: "btn btn-primary",
            to: { name: 'NoticeList' }
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" 戻る ")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_dismissible_alert, {
          color: "danger",
          class: "mt-3",
          message: _ctx.requestError,
          onDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestError = null))
        }, null, 8, ["message"]),
        _createElementVNode("form", {
          onKeyup: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          class: "mt-5"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              id: "title",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.title }]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.values.title) = $event))
            }, null, 2), [
              [_vModelText, _ctx.values.title]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.title)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _withDirectives(_createElementVNode("input", {
              id: "start-date",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.startDate }]),
              type: "date",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.values.startDate) = $event))
            }, null, 2), [
              [_vModelText, _ctx.values.startDate]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.startDate)
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("input", {
              id: "end-date",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.endDate }]),
              type: "date",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.values.endDate) = $event))
            }, null, 2), [
              [_vModelText, _ctx.values.endDate]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.endDate)
            }, null, 8, _hoisted_12)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _withDirectives(_createElementVNode("textarea", {
              id: "body",
              class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.detail }]),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.values.detail) = $event)),
              rows: "15"
            }, null, 2), [
              [_vModelText, _ctx.values.detail]
            ]),
            _createElementVNode("div", {
              class: "invalid-feedback",
              textContent: _toDisplayString(_ctx.errors.detail)
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
              disabled: !_ctx.meta.valid
            }, "保存", 8, _hoisted_17)
          ])
        ], 32)
      ])
    ]),
    _: 1
  }))
}